import useSWR from "swr";
import ApiClient from "../helpers/ApiClient";

const fetcher = (url) => ApiClient.get(url).then((res) => res.data);

export function useTips(filters = {}) {
  const queryParams = new URLSearchParams();
  if (filters.from) queryParams.append("from", filters.from);
  if (filters.to) queryParams.append("to", filters.to);
  if (filters.status && filters.status !== "all") queryParams.append("status", filters.status);
  if (filters.distribution_type && filters.distribution_type !== "all") queryParams.append("distribution_type", filters.distribution_type);
  if (filters.employee_id) queryParams.append("employee_id", filters.employee_id);
  if (filters.search) queryParams.append("search", filters.search);

  const queryString = queryParams.toString();
  const APIURL = `/tips${queryString ? `?${queryString}` : ""}`;

  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher, {
    revalidateOnFocus: false,
  });

  return {
    tips: data?.tips || [],
    summary: data?.summary || {
      total_collected: 0,
      direct_tips: 0,
      pooled_tips: 0,
      pending_allocation_tips: 0,
      paid_tips: 0,
      pending_payout: 0,
      count_active: 0,
      count_paid: 0,
    },
    error,
    isLoading,
    mutate,
    APIURL,
  };
}

export function useStaffOptions() {
  const APIURL = `/tips/staff-options`;
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher, {
    revalidateOnFocus: false,
  });

  return {
    staff: data?.staff || [],
    error,
    isLoading,
    mutate,
  };
}

export async function payoutTips(tip_ids, payout_method = "Cash", notes = "") {
  try {
    const response = await ApiClient.post("/tips/payout", {
      tip_ids,
      payout_method,
      notes,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function allocatePoolTip(tip_id, allocations = []) {
  try {
    const response = await ApiClient.post(`/tips/${tip_id}/allocate`, {
      allocations,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}
